const T_PREFIX = "collapsible-banner";

export const collapsibleBannerTrns = {
  showMoreBtn: `${T_PREFIX}.show-more-btn`,
  showLessBtn: `${T_PREFIX}.show-less-btn`,
};
